// Tags
export const ACTION_LIST_ITEM_TAG = "ch-action-list-item";
export const ACTION_LIST_GROUP_TAG = "ch-action-list-group";
// Selectors
export const ACTION_LIST_ITEM_SELECTOR = (id) => `${ACTION_LIST_ITEM_TAG}[id="${id}"]`;
export const ACTION_LIST_GROUP_SELECTOR = (id) => `${ACTION_LIST_GROUP_TAG}[id="${id}"]`;
export const getActionListOrGroupItemFromEvent = (event) => {
    event.stopPropagation();
    return event.composedPath().find(el => {
        const tagName = el.tagName?.toLowerCase();
        return (tagName === ACTION_LIST_ITEM_TAG || tagName === ACTION_LIST_GROUP_TAG);
    });
};
export const getActionListOrGroupItemIndex = (item, items) => items.findIndex((el) => el.id && el.id === item.id);
export const getParentArray = (itemUIModel) => itemUIModel.root ??
    itemUIModel.parentItem.items;
export const getActionListItemOrGroupInfo = (itemId, flattenedModel) => flattenedModel.get(itemId).item;
